// extracted by mini-css-extract-plugin
export default {"container":"systemsettings_container__88RPl","TabsContent":"systemsettings_TabsContent__EmgL5","RowTabs":"systemsettings_RowTabs__BKtDo"};